'use client';

import { useMemo } from 'react';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

export type ClipboardWriteVars =
  | { text: string }
  | { items: ClipboardItem[] };

export async function writeClipboard(vars: ClipboardWriteVars): Promise<void> {
  if (typeof navigator === 'undefined' || !navigator.clipboard) {
    throw new Error('Clipboard is not supported.');
  }

  if ('text' in vars) {
    if (typeof navigator.clipboard.writeText !== 'function') {
      throw new Error('Text clipboard writes are not supported.');
    }
    await navigator.clipboard.writeText(vars.text);
    return;
  }

  if (typeof navigator.clipboard.write !== 'function') {
    throw new Error('Clipboard item writes are not supported.');
  }
  await navigator.clipboard.write(vars.items);
}

export function useClipboard(): ActionResult<ClipboardWriteVars, void> {
  return useActionHook<ClipboardWriteVars, void>(
    useMemo(
      () => ({ mutationFn: writeClipboard }),
      [],
    ),
  );
}
